import styled from 'styled-components';

import { COLORS, ANIM, MOBILE } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const GaugeWrap = styled.div<{ $size: number; $mobileSize: number }>`
  position: relative;
  width: ${(p) => p.$size}px;
  height: ${(p) => p.$size}px;
  flex: 0 0 auto;

  /* Bigger on desktop, smaller on mobile (the SVG fills the box via its viewBox). */
  ${MOBILE} {
    width: ${(p) => p.$mobileSize}px;
    height: ${(p) => p.$mobileSize}px;
  }
`;

export const GaugeCenter = styled.div<{ $animate: boolean }>`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* Default (and reduced-motion) state: in place, fully shown. */
  opacity: 1;
  transform: translateY(0);

  /* Slight fade + rise on mount, matching the acquisition hero gauge. */
  @media (prefers-reduced-motion: no-preference) {
    opacity: ${(p) => (p.$animate ? 1 : 0)};
    transform: translateY(${(p) => (p.$animate ? 0 : 4)}px);
    transition:
      opacity ${ANIM.NUMBER_RISE_MS}ms ${ANIM.EASE},
      transform ${ANIM.NUMBER_RISE_MS}ms ${ANIM.EASE};
  }
`;

export const GaugeScore = styled.div<{ $mobileScale: number }>`
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  color: ${COLORS.text};

  ${MOBILE} {
    font-size: calc(26px * ${(p) => p.$mobileScale});
  }
`;

export const GaugeStatus = styled(Text)<{ $color: string; $mobileScale: number }>`
  font-size: 13px;
  margin-top: 4px;
  color: ${(p) => p.$color};

  ${MOBILE} {
    font-size: calc(13px * ${(p) => p.$mobileScale});
  }
`;